import { Group, Text, UnstyledButton } from '@mantine/core';
import { useLocation, useNavigate } from 'react-router-dom';
import { CUSTOM_ICONS, ROUTE_ALIASES } from '@/types';
import { Icon, type IconName } from '@/components';
import styles from './Navigation.module.sass';
import cx from 'clsx';

type Route = {
  path: string;
  label: string;
  icon: IconName;
};

const routes: Route[] = [
  { path: ROUTE_ALIASES.ORGANIZATIONS, label: 'Organizations', icon: CUSTOM_ICONS.CHURCH_SOLID },
  { path: ROUTE_ALIASES.SHORT_CODES, label: 'Short Codes', icon: 'IconMessageFilled' },
  { path: ROUTE_ALIASES.BACKGROUNDS, label: 'Backgrounds', icon: 'IconPhotoFilled' },
  { path: ROUTE_ALIASES.SUPER_ADMINS, label: 'Super Admins', icon: 'IconUsers' },
  { path: ROUTE_ALIASES.CHURCH_ADMINS, label: 'Church Admins', icon: CUSTOM_ICONS.CHURCH_SOLID },
  { path: ROUTE_ALIASES.SUGGESTED_MODULES, label: 'Suggested Modules', icon: 'IconLayoutList' },
  { path: ROUTE_ALIASES.MESSAGE_TEMPLATES, label: 'Message Templates', icon: 'IconTemplate' },
  { path: ROUTE_ALIASES.FORM_TEMPLATES, label: 'Form Templates', icon: 'IconListCheck' },
  { path: ROUTE_ALIASES.REPORTS, label: 'Reports', icon: 'IconChartBar' },
];

const NAVIGATION_ICON_SIZE = 20;

export const Navigation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  if (location.pathname === ROUTE_ALIASES.LOGIN) {
    return null;
  }

  return (
    <Group className={styles.container} px="md" justify="center" gap="lg">
      {routes.map((route) => (
        <UnstyledButton
          key={route.path}
          onClick={() => navigate(route.path)}
          className={`${styles.navigationButton} ${location.pathname.includes(route.path) ? styles.activeTabIndicator : ''}`}
        >
          <Group gap="xs">
            <Icon
              name={route.icon}
              className={cx({
                [styles.navigationCustomIcon]: Object.values(CUSTOM_ICONS).includes(route.icon as CUSTOM_ICONS),
              })}
              size={NAVIGATION_ICON_SIZE}
            />
            <Text>{route.label}</Text>
          </Group>
        </UnstyledButton>
      ))}
    </Group>
  );
};
